import { DEFAULT_PAGINATION } from '../../bank-movements/constants/bankMovementsConstants';

const buildInitialDateRange = () => {
  const today = new Date();
  const start = new Date(today.getFullYear(), today.getMonth(), 1);
  const toISODate = (date) => date.toISOString().split('T')[0];

  return {
    startDate: toISODate(start),
    endDate: toISODate(today),
  };
};

export const CASH_RETENTIONS_DEFAULT_FILTERS = buildInitialDateRange();

export const CASH_RETENTIONS_ITEMS_PER_PAGE = DEFAULT_PAGINATION.rowsPerPage;

export const RECONCILIATION_OPTIONS = [
  { value: 'all', label: 'Todos' },
  { value: 'reconciled', label: 'Conciliados' },
  { value: 'pending', label: 'Pendientes' },
];

